module.exports = __webpack_public_path__ + "static/img/jxjlh3.3ddba4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jxjlh3.png
// module id = fjI1
// module chunks = 1